<template>
  <el-drawer
    ref="drawerRef2"
    :title="title"
    size="55%"
    :visible.sync="drawerView"
    :before-close="handleClosed"
    @closed="handleClosed"
    v-bind="$attrs"
    :loading="autoLoading"
  >
    <div style="padding: 50px; height: 100%; background: rgb(233, 233, 233)">
      <el-form ref="el_form" label-position="top" size="mini">
        <div style="display: inline-flex; float: right">
          <el-form-item label="Año">
            <!-- FITLRO DE AÑO -->
            <el-select v-model="YearDra" placeholder="Año" size="mini">
              <el-option
                v-for="item in years"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Tipo de meta">
            <div class="box">
              <el-select
                v-model="type"
                clearable
                placeholder="Metas"
                size="mini"
              >
                <el-option
                  v-for="item in metas"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>

        <div class="formEditGoal" style="display: flex; width: 100%; gap: 10px">
          <el-card class="cardInputs">
            <h3>Q1</h3>
            <el-form-item label="Enero">
              <el-input-number
                :controls="false"
                v-model="JanuaryDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Febrero">
              <el-input-number
                :controls="false"
                v-model="FebruaryDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Marzo">
              <el-input-number
                :controls="false"
                v-model="MarchDra"
              ></el-input-number>
            </el-form-item>
          </el-card>

          <el-card class="cardInputs">
            <h3>Q2</h3>
            <el-form-item label="Abril">
              <el-input-number
                :controls="false"
                v-model="AprilDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Mayo">
              <el-input-number
                :controls="false"
                v-model="MayDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Junio">
              <el-input-number
                :controls="false"
                v-model="JuneDra"
              ></el-input-number>
            </el-form-item>
          </el-card>

          <el-card class="cardInputs">
            <h3>Q3</h3>
            <el-form-item label="Julio">
              <el-input-number
                :controls="false"
                v-model="JulyDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Agosto">
              <el-input-number
                :controls="false"
                v-model="AugustDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Septiembre">
              <el-input-number
                :controls="false"
                v-model="SeptemberDra"
              ></el-input-number>
            </el-form-item>
          </el-card>

          <el-card class="cardInputs">
            <h3>Q4</h3>
            <el-form-item label="Octubre">
              <el-input-number
                :controls="false"
                v-model="OctoberDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Noviembre">
              <el-input-number
                :controls="false"
                v-model="NovemberDra"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Diciembre">
              <el-input-number
                :controls="false"
                v-model="DecemberDra"
              ></el-input-number>
            </el-form-item>
          </el-card>
        </div>

        <el-form-item
          label=""
          label-width="0"
          style="margin-top: 40px; float: right"
        >
          <el-button
            type="info"
            :loading="autoLoading"
            :disabled="autoLoading"
            @click="handleClosed"
            >Cancel</el-button
          >
          <el-button
            type="primary"
            :loading="autoLoading"
            :disabled="autoLoading"
            @click="onSubmit()"
          >
            Actualizar
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "GoalsFormDrawer",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initModel: {
      type: Object,
      required: false,
      default: () => {}
    },
    type: {
      type: [Number, String],
      default: 1
    },
    codeVendor: {
      type: [Number, String],
      default: ""
    },
    JanuaryDra: {
      type: Number,
      default: null,
      required: false
    },
    FebruaryDra: {
      type: Number,
      default: null,
      required: false
    },
    MarchDra: {
      type: Number,
      default: null,
      required: false
    },
    AprilDra: {
      type: Number,
      default: null,
      required: false
    },
    MayDra: {
      type: Number,
      default: null,
      required: false
    },
    JuneDra: {
      type: Number,
      default: null,
      required: false
    },
    JulyDra: {
      type: Number,
      default: null,
      required: false
    },
    AugustDra: {
      type: Number,
      default: null,
      required: false
    },
    SeptemberDra: {
      type: Number,
      default: null,
      required: false
    },
    OctoberDra: {
      type: Number,
      default: null,
      required: false
    },
    NovemberDra: {
      type: Number,
      default: null,
      required: false
    },
    DecemberDra: {
      type: Number,
      default: null,
      required: false
    },
    YearDra: {
      type: Number,
      default: null,
      required: false
    }
  },
  data() {
    return {
      autoLoading: false,
      drawerView: false,
      metasValue: "",
      metas: [
        { label: "Venta", value: 1 },
        { label: "Prospección", value: 2 },
        { label: "Presentación", value: 3 },
        { label: "Cotización", value: 4 }
      ]
    };
  },
  watch: {
    initModel(val) {
      this.model = val;
    }
  },
  computed: {
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 1; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },
  methods: {
    handleOpen() {
      this.drawerView = true;
    },
    handleClosed() {
      this.drawerView = false;
    },
    onSubmit() {
      this.autoLoading = true;
      //const result = this.metas.find((element) => (element.label = this.type));

      this.$http
        .put("/api/deals/editgoalsvendor", {
          Cod_Vendor: this.codeVendor,
          January: this.JanuaryDra,
          February: this.FebruaryDra,
          March: this.MarchDra,
          April: this.AprilDra,
          May: this.MayDra,
          June: this.JuneDra,
          July: this.JulyDra,
          August: this.AugustDra,
          September: this.SeptemberDra,
          October: this.OctoberDra,
          November: this.NovemberDra,
          December: this.DecemberDra,
          Year: this.YearDra,
          Type: this.type
        })
        .then((response) => {
          this.data = response.data;
          //this.$emit("refresh-table");
          //this.$store.commit("deals/EditGoals", response.data);
          //this.handleClosed();
          this.$message.success("Meta actualizada");
        })
        .catch((error) => {
          this.$message.error("Error", error);
        })
        .finally(() => {
          this.autoLoading = false;
          this.drawerView = false;
          this.$emit("updateGoal");
        });
    }
  }
};
</script>
<style scoped>
.formEditGoal {
  display: flex;
  justify-content: flex-end;
}
.formEditGoal .cardInputs h3 {
  text-align: center;
}
.formEditGoal .cardInputs {
  width: 250px;
  box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
  -webkit-box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
}
</style>
